// The System / Light / Dark / Night picker (lib/screenLook.ts). Profile, the
// boat's Settings page (TOM-159) and the slide-in sidebar each draw one; all
// three change the same look, which a signed-in account also keeps (TOM-944).
import { SCREEN_LOOKS, useScreenLook } from '../lib/screenLook';

export function ScreenLookChoice({
  className,
  labelledBy,
  label,
  testIdPrefix,
}: {
  className?: string;
  /** Id of the heading that names the group; or pass `label`. */
  labelledBy?: string;
  label?: string;
  testIdPrefix?: string;
}) {
  const [look, setLook] = useScreenLook();
  return (
    <div
      className={className ? `tb-seg ${className}` : 'tb-seg'}
      role="group"
      aria-labelledby={labelledBy}
      aria-label={labelledBy ? undefined : label}
    >
      {SCREEN_LOOKS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className="tb-seg__opt"
          aria-pressed={look === opt.value}
          onClick={() => setLook(opt.value)}
          data-testid={testIdPrefix ? `${testIdPrefix}-${opt.value}` : undefined}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
